import { Dialog } from '@angular/cdk/dialog';
import { Component, Inject, inject, Input, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { values } from 'lodash';
import { CommonDialogData } from 'src/app/models/CommonDialogData';
import { ApiService } from 'src/app/services/api.service';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { LogoutBusinessLogicService } from 'src/app/services/logout-business-logic.service';
import { BatchAlertService } from 'src/app/services/batch-alert.service';

import { Tab } from 'src/app/models/tab.model';
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  iconConfig: any;

  timeoutMsg = Constants.Timeout_Msg;

  @Input()
  msg!: string;

  constructor(
    public rootScope: RootScopeService,
    public apiService: ApiService,
    public genesysCloudService: GenesysCloudService,
    public router: Router, public logOutService: LogoutBusinessLogicService,
    public batchAlertService: BatchAlertService,
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogData
  ) {
    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal',
    };
  }

  ngOnInit(): void { }



  modelClosed() {
    this.apiService.handleMultiSession(false);
  }

  // Common method for Button Click
  commonButton(type) {
    switch (type) {
      case Constants.buttonEnum.restoreLastSession:
        {
          this.modelClosed();

          if (this.batchAlertService.checkBatchAlertModeActive()) {
            this.batchAlertService.turnBatchAlertModeOnWithoutRoute();
          }
        }
        break;
      case Constants.buttonEnum.opneNewSession:
        this.apiService.handleMultiSession(true);
        sessionStorage.removeItem('isBatchAlertModeActive');
        break;
      case 'I’ll call later':
        {
          // console.log("hello i am : I’ll call late ")
        }

        break;
      case 'Got it':
        this.rootScope.isModelopen = false;
        if (this.data.comingFrom == Constants.comptFrom.Max_Account) {
          // let tabs = this.rootScope.customerTabs;
          if (this.rootScope.checkCallOrChat()) {

            setTimeout(() => {
              if (this.rootScope.holdLiveDetails[0]?.id)
                this.genesysCloudService.customerService.showPopup();
            }, 15000);
          } else {
            this.rootScope.customerLink =
              this.rootScope.activeCustTab?.customerSessionId ? this.rootScope.activeCustTab.customerSessionId : 0; //?tabs[tabs.length - 1].id;

            /*check if customerLink exist in the opened customer tab's . 
            If not exist then update the this.rootScope.customerLink to zero . So that it redirect to Customer Search Tab , 
            rather then any invalid route */

            let existingTab = this.rootScope.getObjFromArray(
              this.rootScope.customerTabs,
              'customerSessionId',
              this.rootScope.customerLink
            );


            if (existingTab == undefined) {
              this.rootScope.customerLink = 0;
            }


            this.genesysCloudService.customerService.updateActiveTabDetails(this.rootScope.customerLink);


            // Added condition to implemenent CCR1-3203 issue no 2

            if (this.rootScope.customerLink != 0) {

              this.rootScope.router.navigate(
                [`/customer-account/${this.rootScope.customerLink}`],
                {
                  skipLocationChange: true,
                }
              );
            }

          }
        } else if (this.data.comingFrom == 'userprofile') {
          this.rootScope.customerLink =
            this.rootScope.activeCustTab.customerSessionId; //?tabs[tabs.length - 1].id;
          this.genesysCloudService.customerService.updateActiveTabDetails(
            this.rootScope.customerLink
          );

          if ([Constants.SIMULATION_MANAGER, Constants.CUSTOMER_SEARCH].includes(this.rootScope.activeLink)) {
            return;
          }
          if (this.rootScope.activeLink != Constants.CUSTOMER_SEARCH)
            this.rootScope.activeLink = Constants.CUSTOMER_SEARCH;
          if (this.rootScope.activeLink == Constants.CCR_Dashboard) {
            this.rootScope.router.navigate([`/customer-search`], {
              skipLocationChange: true,
            });
          }

          if (this.rootScope?.activeCustTab?.id == 1) {
            this.rootScope.router.navigate([`/customer-search-unidentified-call/${this.rootScope.customerLink}`], {
              skipLocationChange: true,
            });
          } else {
            this.rootScope.router.navigate(
              [`/customer-account/${this.rootScope.customerLink}`],
              {
                skipLocationChange: true,
              }
            );
          }
        }
        else if (this.data.comingFrom == Constants.buttonEnum.multipleAccount) {
          this.navigateToActiveCustomerTab(this.data?.rowData as Tab);

        }
        break;
      case Constants.buttonEnum.stillWorking://timeout button 
        this.rootScope.clearInterval = true;
        break;
      case Constants.buttonEnum.logOut://timeout button 
        this.rootScope.clearInterval = true;
        this.logOutService.validateLogOut(this);
        break

      case Constants.buttonEnum.continue:
        if (this.rootScope.invalidENV) {
          this.rootScope.invalidENVBanner = true;
          this.rootScope.invalidENV = false;
          console.log("Invalid Environment");
        }
        else
          this.rootScope.turnSimulationModeOn();

        break;

      case Constants.CANCEL_BUTTON_TYPE:


        setTimeout(() => {
          this.rootScope.simulationData.isSimulationToggleOn = false;

          this.rootScope.simulationData.isSimulationModeActive = false;
        }, 500);

        break;
      //CCR3-10534
      case Constants.buttonEnum.doNotRegister:
        this.genesysCloudService.logOutUser(true).subscribe((res) => {
          if (res)
            console.log(res);
        });
        this.apiService.genesysLogout(this.rootScope.invalidENV);
        break;
      case Constants.buttonEnum.acknowledge:
        this.rootScope.desktopIndicatorModel = false;
        break;
      default:
        break;
    }
  }

  /**
   * Navigates to the active customer tab specified by the given `tab` object.
   *CCR3-13182
   * This method performs the following actions:
   * - Finds and sets the active customer tab using the `customerSessionId` from the provided `tab`.
   * - Updates the `domainIndex` of the active customer tab to the wrap-up domain.
   * - Handles TBA (To Be Announced) show/hide conditions as per CCR3-3401.
   * - Retains the selected row on tab switch by cloning the active customer tab (CCR1-5659).
   * - Updates the `customerLink` with the current `customerSessionId`.
   * - Navigates to the customer account route for the selected customer tab without updating the browser's URL.
   *
   * @param tab - The tab object containing the `customerSessionId` to activate.
   */
  navigateToActiveCustomerTab(tab: Tab): void {
    // Find and set the active customer tab by customerSessionId
    const activeTab = this.rootScope.getObjFromArray(
      this.rootScope.customerTabs,
      'customerSessionId',
      tab.customerSessionId
    );
    if (!activeTab) return;

    this.rootScope.activeCustTab = activeTab;
    this.rootScope.activeCustTab.domainIndex = {
      domainId: Constants.navMenu.wrap_up,
      domainName: Constants.navMenu.wrap_up,
    };

    // Handle TBA show/hide conditions (CCR3-3401)
    this.rootScope.hideAndShowTBA(Constants.TBA_COMMANDS.SHOW, tab.customerSessionId);

    // Retain selected row on tab switch (CCR1-5659)
    this.rootScope.clonedActiveCustTab = _.cloneDeep(this.rootScope.activeCustTab);

    this.rootScope.customerLink = tab.customerSessionId;

    this.router.navigate(
      [`/customer-account/${this.rootScope.customerLink}`],
      { skipLocationChange: true }
    );
  }

  ngOnDestroy() {
    this.rootScope.scrollToTop();
  }
}
